import { makeStyles } from '@material-ui/styles';
import { Values } from '../../../../values/Values';


const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(5),
  },
  gridBotoes: {
    marginRight: 30,
    marginLeft: 30
  },
  gridBotaoFinalizar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  gridBotaoCancelar: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  botaoCancelar: {
    backgroundColor: theme.palette.error.main
  }
}));

export {useStyles}

